<script lang="ts">
  import { auraSeconds } from '../../game/hud.svelte';
  import type { LossOfControl } from '../../game/lossOfControl';

  let { loss }: { loss: LossOfControl } = $props();
  const left = $derived(
    loss.duration > 0 ? Math.min(1, loss.remaining / loss.duration) : 0,
  );
</script>

<div
  class="loss"
  class:full={loss.full}
  class:root={loss.kind === 'root'}
  role="alert"
>
  <div class="icon">
    <img src="/icons/{loss.icon}.webp" alt="" />
    <span
      class="sweep"
      style="background: conic-gradient(rgba(0,0,0,0.65) {left *
        360}deg, transparent 0)"
    ></span>
  </div>
  <div class="text">
    <span class="label">{loss.label}</span>
    <span class="name">{loss.name}</span>
  </div>
  <span class="time">{auraSeconds(loss.remaining)}</span>
  <div class="bar"><div style="width: {left * 100}%"></div></div>
</div>

<style>
  .loss {
    --tone: #b46cff;
    position: relative;
    display: flex;
    align-items: center;
    gap: 14px;
    width: 380px;
    padding: 10px 28px 14px;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(10, 6, 14, 0.85) 18%,
      rgba(10, 6, 14, 0.85) 82%,
      transparent
    );
    border-image: linear-gradient(
        90deg,
        transparent,
        var(--tone) 20%,
        var(--tone) 80%,
        transparent
      )
      1;
    border-width: 2px 0;
    border-style: solid;
    text-shadow:
      0 0 3px black,
      0 1px 2px black;
  }
  .loss.full {
    --tone: #e8382a;
  }
  .loss.root {
    --tone: #e8a23a;
  }
  .icon {
    position: relative;
    flex: none;
    width: 60px;
    height: 60px;
    border: 2px solid var(--tone);
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 0 12px var(--tone);
  }
  .icon img,
  .sweep {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }
  .text {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 0;
  }
  .label {
    font-size: 26px;
    font-weight: bold;
    color: var(--tone);
  }
  .name {
    font-size: 14px;
    color: #d8d2c4;
  }
  .time {
    font-size: 30px;
    font-weight: bold;
    color: white;
    font-variant-numeric: tabular-nums;
  }
  .bar {
    position: absolute;
    left: 20%;
    right: 20%;
    bottom: 5px;
    height: 3px;
    background: rgba(0, 0, 0, 0.6);
  }
  .bar div {
    height: 100%;
    background: var(--tone);
  }
</style>
